export const TrendAlerts = {
    ir: {
        title: 'Internal Rotation',
        warning: `We recommended no pitching because you lost significant IR Strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant IR Strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    },
    er: {
        title: 'External Rotation',
        warning: `We recommended no pitching because you lost significant ER Strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant ER Strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    },
    scaption: {
        title: 'Scaption',
        warning: `We recommended no pitching because you lost significant Scaption Strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant Scaption Strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    },
    grip: {
        title: 'Grip',
        warning: `We recommended no pitching because you lost significant Grip Strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant Grip Strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    },
    multiple: {
        title: 'Multiple Muscles',
        warning: `We recommended no pitching because you lost significant arm strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant arm strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    },
    totalstrenght: {
        title: 'Overall',
        warning: `We recommended no pitching because you lost significant arm strength in consecutive exams. 
                Take another Fresh Exam in 24-48 hours to ensure your arm is recovered prior to pitching. 
                Keep throwing to a minimum until your arm is recovered.`,
        medical: `We recommend no pitching and suggest seeing a licensed medical professional because you've lost significant arm strength in consecutive exams. 
                Take a week off from throwing for recovery and monitor progress with Fresh Exams every 48 hours. 
                Continue ArmCare strength training unless advised otherwise by a professional.`
    }
}